import React from 'react';
import styles from 'components/ScenarioSetup/ActionIcons/ActionIcons.module.css';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { FunnelIconDropped } from 'assets/icons/FunnelIconDropped';
import { FunnelIconAlt } from 'assets/icons/FunnelIconAlt';

export const Funnel = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const classNameExtension = styles.actionFunnel;

    const actionIconConditions = {
        base: {
            icon: FunnelIconDropped,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#00C6A2'
            }
        },
        opened: {
            icon: FunnelIconAlt,
            iconProps: { borderColor: '#00C6A2' }
        },
        warning: {
            icon: FunnelIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions,
        classNameExtension
    }} />
}
